module.exports = __webpack_public_path__ + "assets/img/Main material (24).69823666.jpg";